import { getOrgID, getUri, patchUri, postUri } from '../utils/fetch';
import Env from '../utils/env';
import { IConfig } from '@rhc-shared-components/control-wrapper';
import { IProjectRhcertStatus } from "../interfaces/projectRhcert";
import { getTaticIdObj } from "../utils/getTaticIdObj";
import { IOnBoardingStatusResponse } from "../interfaces/common";

// GETs the Onboarding Status
export const getOnboardingStatus = (abortSignal?: AbortSignal): Promise<any> => {
  const uri = Env.hydraAPIURL
    .clone()
    .setPath(`${Env.hydraAPIPrefix}/companies/current/onboarding/status`);

  const additionalParams: RequestInit = {};

  if (abortSignal) {
    Object.assign(additionalParams, { signal: abortSignal });
  }
  const taticData = getTaticIdObj();
  if (Object.keys(taticData).length > 0) {
    const taticHeaders: HeadersInit = {
      ...(taticData?.internalTacticId && {
        'x-rh-omni-itc': taticData.internalTacticId,
      }),
      ...(taticData?.externalTacticId && {
        'x-rh-omni-tc': taticData.externalTacticId,
      }),
      ...(taticData?.personalizationTacticId && {
        'x-rh-omni-pc': taticData.personalizationTacticId,
      }),
    };
    Object.assign(additionalParams, { headers: taticHeaders });
  }
  return getUri<IOnBoardingStatusResponse>(uri, additionalParams);
};

// Request to sell on marketplace
// Builds request data
const assignData = (objectToAssign, cookie, cookieKey, objectKey) => {
  if (cookie[cookieKey]) {
    Object.assign(objectToAssign, { [objectKey]: cookie[cookieKey] });
  }
  return objectToAssign;
};

export const sellOnMarketplace = (
  rhpcProjectId: string,
  projectName: string
): Promise<any> => {
  let data = {};
  // phone, company is optional
  const userData = window?.sessionjs?.getuserInfo();
  data = assignData(data, userData, 'firstName', 'fname');
  data = assignData(data, userData, 'lastName', 'lname');
  data = assignData(data, userData, 'email', 'email');
  data = assignData(data, userData, 'organization_id', 'rhpcVendorId');
  Object.assign(data, {
    rhpcProjectId,
    product: projectName,
    channel: 'REDHAT',
    rhpcVendorId: getOrgID(),
  });
  const uri = Env.hydraProxyURL
    .clone()
    .setPath(`${Env.hydraProxyPrefix}/omNomination/create`);
  return postUri(uri, data);
};

//Creates the RHEL or OpenStack non container project
export const createPfsNonContainerProject = (payload): Promise<any> => {
  const uri = `${Env.ConnectPortalUrls[Env.getEnvName()]}${Env.pfsNonContainerPrefix}`;
  return postUri(uri, payload);
};

//Patches the RHEL or OpenStack Non Container Project
export const updatePfsNonContainerProject = (pyxisId, payload): Promise<any> => {
  const uri = `${Env.ConnectPortalUrls[Env.getEnvName()]}${Env.pfsNonContainerPrefix}/pyxis-id/${pyxisId}`;
  return patchUri(uri, payload);
}

// GETs the config values
export const getCwfConfig = (): Promise<IConfig[]> => {
  const uri = Env.hydraProxyURLPreprodStage
    .clone()
    .setPath(`${Env.hydraRestPrefix}/cwf_config`);
  return getUri(uri);
}
export const getProjectRhcertCase = (projectId, abortSignal?: AbortSignal): Promise<IProjectRhcertStatus> => {
  const uri = Env.hydraProxyURL.clone().setPath(`${Env.hydraCwePrefix}/${projectId}/certification`);
  const params = abortSignal ? { "signal": abortSignal } : {};
  return getUri(uri, params);
}

export const createProjectRhcertCase = (projectId): Promise<any> => {
  const uri = Env.hydraProxyURL.clone().setPath(`${Env.hydraCwePrefix}/certifications`);
  return postUri(uri, projectId);
};

